import styled from '@emotion/styled'
// @ts-ignore
import {css} from '@emotion/react'
import {LibButton, LibButtonProps} from '../../elements/LibButton'

export interface Theme {
    colors: Record<string, string>
    bps: Record<string, string>
    fontSize: Record<string, string>
    fontFamily: Record<string, string>
}

const Modal = styled.div`
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const ModalHeader = styled.div`
    margin: 0 auto;
`

const ModalBody = styled.div`
    min-width: 300px;
    text-align: center;
`

const CloseButton = styled(LibButton)<LibButtonProps & {theme: Theme}>`
    white-space: nowrap;
    margin-top: 1rem;

    @media (max-width: ${props => props.theme.bps.sm}) {
        padding: 0.5rem 0.75rem;
    }
    
    ${({ theme }) => css`
        background-color: ${theme.colors.white};
        color: ${theme.colors.primary};
        border: 2px solid ${theme.colors.primary};
    `}
`

export { Modal, ModalHeader, ModalBody, CloseButton }